module.exports = __webpack_public_path__ + "img/kapian.cd43d231.png";